import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ProfileFields from './ProfileFields/ProfileFields';
import CustomFields from './CustomFields/CustomFields';

const IN = (props) => {
	const { t, i18n } = useTranslation();

	const {formFields, setFormFields, count, form_component} = props;
	const {page, profile_fields} = formFields;

	const renderComponent = () => {
		switch (form_component.type) {
			case 'CF':
			case 'SF':
				return (
					<ProfileFields
						key={`component-${count}`}
						lang={props.lang}
						formFields={formFields}
						count={count}
						form_component={form_component}
					/>
				);
			
			case 'CPF':
				// Check if profile_fields is an array or object
				if (Array.isArray(profile_fields)) {
					for (let index = 0; index < profile_fields.length; index++) {
						const profile_field = profile_fields[index];
						if (profile_field.fieldname === form_component.fieldname) {
							const updatedFieldname = `profile_custom_fields[${form_component.fieldname}]`;
							// Create a copy of form_component to avoid mutating the original
							const updatedFormComponent = {
								...form_component,
								fieldname: updatedFieldname
							};

							return (
								<CustomFields
									key={`component-${count}-${index}`}
									lang={props.lang}
									formFields={formFields}
									count={count}
									form_component={updatedFormComponent}
								/>
							);
						}
					}
				} else if (profile_fields && typeof profile_fields === 'object') {
					// If profile_fields is an object, check if the fieldname exists as a key
					if (profile_fields[form_component.fieldname]) {
						const updatedFieldname = `profile_custom_fields[${form_component.fieldname}]`;
						// Create a copy of form_component to avoid mutating the original
						const updatedFormComponent = {
							...form_component,
							fieldname: updatedFieldname
						};

						return (
							<CustomFields
								key={`component-${count}`}
								lang={props.lang}
								formFields={formFields}
								count={count}
								form_component={updatedFormComponent}
							/>
						);
					}
				}
				
				// If no match found, still render the component for CPF type
				const updatedFieldname = `profile_custom_fields[${form_component.fieldname}]`;
				const updatedFormComponent = {
					...form_component,
					fieldname: updatedFieldname
				};
				
				return (
					<CustomFields
						key={`component-${count}`}
						lang={props.lang}
						formFields={formFields}
						count={count}
						form_component={updatedFormComponent}
					/>
				);

			case 'PCU':
				return (
					<CustomFields
						key={`component-${count}`}
						lang={props.lang}
						formFields={formFields}
						count={count}
						form_component={form_component}
					/>
				);

			default:
				return null;
		}
	};

	return (
		<div className="quest fixtop mb-3 d-flex gap-3">
			{page.show_ques_num && (
				<div className="badge-circle badge-light-dark badge">{count}</div>
			)}
			{renderComponent()}
		</div>
	);
}

export default IN;